import { render, staticRenderFns } from "./CateringBotModal.vue?vue&type=template&id=3116e7b5&scoped=true"
import script from "./CateringBotModal.vue?vue&type=script&lang=ts"
export * from "./CateringBotModal.vue?vue&type=script&lang=ts"
import style0 from "./CateringBotModal.vue?vue&type=style&index=0&id=3116e7b5&prod&lang=scss"
import style1 from "./CateringBotModal.vue?vue&type=style&index=1&id=3116e7b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116e7b5",
  null
  
)

export default component.exports